import React, {
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
} from 'react';
import { Trigger } from '@radix-ui/react-popover';

export const PopoverTrigger: React.FC<{
  asChild?: boolean;
  trigger: ReactNode;
  handleTriggerClick: MouseEventHandler<HTMLElement>;
  mouseEventHandler: (isMouseOver: boolean) => void;
  onKeyUp?: KeyboardEventHandler<HTMLDivElement>;
}> = ({ asChild, trigger, handleTriggerClick, mouseEventHandler, onKeyUp }) => (
  <Trigger
    asChild={asChild}
    onClick={handleTriggerClick}
    onMouseEnter={() => mouseEventHandler(true)}
    onMouseLeave={() => mouseEventHandler(false)}
  >
    {asChild ? (
      <div
        role="link"
        tabIndex={0}
        onClick={handleTriggerClick}
        onMouseEnter={() => mouseEventHandler(true)}
        onMouseLeave={() => mouseEventHandler(false)}
        onKeyUp={onKeyUp}
      >
        {trigger}
      </div>
    ) : (
      trigger
    )}
  </Trigger>
);
